module.exports = __webpack_public_path__ + "img/vector@3x.5cc9cada.png";